/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/bolOauth.scss';

import {AwesomeIcon, ErrorType, Loader, voidFunction, WithBackground} from '@dvrd/dvr-controls';

import classNames from 'classnames';

import React, {MouseEventHandler} from 'react';

import {useTranslation} from 'react-i18next';

import {APIValidationStatus} from '../../../util/interfaces';

import {BolmateButton} from '../../controls';

import {IconName} from '@fortawesome/fontawesome-svg-core';

interface Props {
    onClose: MouseEventHandler;
    onRetry: MouseEventHandler;
    status: APIValidationStatus;
    error: ErrorType;
}

export default function BolOauth(props: Props) {
    const {onClose, onRetry, status, error} = props;
    const {t} = useTranslation();

    function renderStatus() {
        let statusLabel: string;
        if (status === APIValidationStatus.VALIDATING)
            statusLabel = t('oauth.bol.statusValidating', 'Koppeling testen...');
        else if (status === APIValidationStatus.ERROR) statusLabel = t('oauth.bol.statusError', 'Autorisatie mislukt');
        else statusLabel = t('oauth.bol.statusSuccess', 'Koppeling voltooid');
        return <label className='status-label'>{statusLabel}</label>;
    }

    function renderStatusIndicator() {
        let icon: IconName = 'circle-check';
        let iconClass = 'validated';
        if (status === APIValidationStatus.VALIDATING)
            return (
                <>
                    <Loader position='relative' active disableBackground />
                    <label>{t('oauth.bol.testing', 'Eén moment, we testen de verbinding.')}</label>
                </>
            );
        else if (status === APIValidationStatus.ERROR) {
            icon = 'circle-xmark';
            iconClass = 'error';
        }
        return <AwesomeIcon name={icon} className={classNames('status-indicator', iconClass)} />;
    }

    function renderError() {
        if (!error) return null;
        return <label className='error-label'>{error}</label>;
    }

    function renderButton() {
        let label = t('oauth.bol.continue', 'Doorgaan');
        let onClick: MouseEventHandler = onClose;
        const disabled = status === APIValidationStatus.VALIDATING;
        const secondary = status === APIValidationStatus.ERROR;
        if (status === APIValidationStatus.ERROR) {
            label = t('oauth.bol.retry', 'Opnieuw proberen');
            onClick = onRetry;
        }
        return <BolmateButton onClick={onClick} label={label} disabled={disabled} secondary={secondary} />;
    }

    return (
        <WithBackground
            onClose={voidFunction}
            backgroundColor='transparent'
            active
            preventBackgroundClick
            escapeDisabled
        >
            <div className='bol-oauth default-popup'>
                <div className='header-container'>
                    <label className='header-title'>{t('oauth.bol.title', 'Koppeling met Bol')}</label>
                </div>
                <div className='body-container'>
                    {renderStatus()}
                    {renderStatusIndicator()}
                    {renderError()}
                    {renderButton()}
                </div>
            </div>
        </WithBackground>
    );
}
